import React, {useState} from "react";

import StarIcon from "./icons/StarIcon";

import Modal from "./Modal";

import badge from './images/badge.png';

const Stars = ({rating}) => {
    const starCount = 10;

    const starsArray = Array.from({ length: starCount }, (_, i) => (
        <StarIcon
            key={i}
            className={`w-5 ${i < rating ? "fill-[#ffd739] text-[#ffd739]" : "fill-gray-300 text-gray-300"}`}
        />
    ));

    return <div className="flex">{starsArray}</div>;
}

const Skills = ({skillsRef}) => {
    const [isModalOpen, setIsModalOpen] = useState(false);

    const openModal = () => {
      setIsModalOpen(true);
    };
  
    const closeModal = () => {
      setIsModalOpen(false);
    };
  
    return(
        <div ref={skillsRef} className="md:mt-20 md:p-0 Skills p-[20px] mt-10">
            <p className="md:text-6xl font-bold text-4xl">Skills<span className="text-[#ffd739]">_</span></p>
            <div className="mt-4 flex md:flex-row justify-between flex-col">
                <div className="min-w-[220px]">
                    <p className="md:text-2xl font-semibold text-xl">PHP</p>
                    <Stars rating={7}/>
                </div>

                <div className="">
                    <p className="md:text-2xl font-semibold text-xl phone:mt-2">HTML 5</p>
                    <Stars rating={9}/>
                </div>

                <div className="">
                    <p className="md:text-2xl font-semibold text-xl phone:mt-2">CSS 3 & SCSS</p>
                    <Stars rating={9}/>
                </div>
            </div>
            <div className="md:mt-4 flex md:flex-row justify-between flex-col mt-2">
                <div className="min-w-[220px]">
                    <p className="md:text-2xl md:mt-0 font-semibold text-xl mt-2">Javascript & JQuery</p>
                    <Stars rating={8}/>
                </div>
                
                <div className="">
                    <p className="md:text-2xl md:mt-0 font-semibold text-xl mt-2">
                        <a className="flex underline" href="/" onClick={(e) => {
                            e.preventDefault();
                            openModal();
                        }}>
                            Magento 2 
                            <span class="relative flex h-3 w-3">
                                <span class="animate-ping absolute inline-flex h-full w-full rounded-full bg-[#ffd739] opacity-75"></span>
                                <span class="relative inline-flex rounded-full h-3 w-3 bg-[#ffd739]"></span>
                            </span>
                        </a>
                    </p>
                    <Stars rating={7}/>
                </div>

                <div className="">
                    <p className="md:text-2xl md:mt-0 font-semibold phone:flex-col text-xl mt-2">WordPress</p>
                    <Stars rating={6}/>
                </div>
            </div>
            <div className="md:mt-4 flex md:flex-row justify-between flex-col mt-2">
                <div className="min-w-[220px]">
                    <p className="md:text-2xl md:mt-0 font-semibold text-xl mt-2">CodeIgniter</p>
                    <Stars rating={5}/>
                </div>
                <div className="">
                    <p className="md:text-2xl md:mt-0 font-semibold text-xl mt-2">Laravel</p>
                    <Stars rating={4}/>
                </div>

                <div className="">
                    <p className="md:text-2xl md:mt-0 font-semibold text-xl mt-2">C#</p>
                    <Stars rating={4}/>
                </div>
            </div>

            <div className="md:mt-4 flex md:flex-row justify-between flex-col mt-2">
                <div className="">
                <p className="md:text-2xl md:mt-0 font-semibold text-xl mt-2">ASP.NET</p>
                <Stars rating={5}/>
                </div>
            </div>
            

            <Modal isOpen={isModalOpen} onClose={closeModal} title="">
                <div className="md:flex md:flex-row md:space-x-4  items-center">
                    <div className="w-[60%] md:block hidden">
                        <img src={badge} className="w-[100%]"/>  
                    </div>
                    <div className="">
                        <p className="text-xl font-bold">Adobe Certified Expert-Adobe Commerce Front-End Developer</p>
                        <p className="text-lg mt-4">Issued by <a href="https://www.credly.com/organizations/adobe/badges" target="_blank" rel="noreferrer" className="underline text-[#015850]">Adobe</a></p>
                        <p className="mt-4">Earners of this credential have the skills and knowledge needed to understand Adobe Commerce's theming components and the ability to modify the user interface.</p>
                        <p className="hidden md:block text-lg mt-4 font-semibold">Skills</p>
                        <div className="hidden md:flex flex-wrap space-x-4 space-y-4 items-center">
                            <div className="border border-gray-200 p-1 mt-4 ml-4 rounded-md text-wrap">Admin Panel</div>
                            <div className="border border-gray-200 p-1 rounded-md">Adobe Commerce</div>
                            <div className="border border-gray-200 p-1 rounded-md">CSS</div>
                            <div className="border border-gray-200 p-1 rounded-md">Frontend</div>
                            <div className="border border-gray-200 p-1 rounded-md">Javascript</div>
                            <div className="border border-gray-200 p-1 rounded-md">Layouts</div>
                            <div className="border border-gray-200 p-1 rounded-md">Magento</div>
                            <div className="border border-gray-200 p-1 rounded-md">Magento Themes</div>
                            <div className="border border-gray-200 p-1 rounded-md">Modification</div>
                            <div className="border border-gray-200 p-1 rounded-md">Templates</div>
                            <div className="border border-gray-200 p-1 rounded-md">Translations</div>
                            <div className="border border-gray-200 p-1 rounded-md">Design-related System Configuration</div>
                        </div>

                        <p className="md:block text-lg mt-4 font-semibold hidden">Reference</p>
                        <a href="https://www.credly.com/badges/b5103e12-57d7-4078-81e6-44d619cd5562/public_url" className="underline" target="_blank" rel="noreferrer">
                            <span className="hidden md:block">https://www.credly.com/badges/b5103e12-57d7-4078-81e6-44d619cd5562/</span>
                            <span className="block md:hidden text-[#015850]">Click here for more information</span>
                        </a>
                    </div>
                </div>
            </Modal>
        </div>

        
    )
}

export default Skills;